import { BorderRadiusCorners, Box, type Colors } from '@factorialco/deprecated-design-system'

import { nameFromHexCode } from 'modules/shift_management/lib/colors'

interface Props {
  color: string
}

const ColorBlock = ({ color }: Props) => {
  const background: Colors = color ? nameFromHexCode(color) : 'grey400'
  const borderRadius: BorderRadiusCorners = {
    all: 'abs008',
  }
  const boxs = Array.from(Array(5).keys())
  return (
    <>
      <Box
        flexDirection="row"
        background={background}
        borderRadius={borderRadius}
        height="s96"
        width="s12"
        position="relative"
      >
        <Box borderRadius={borderRadius} height="s96" width="s12">
          {boxs.map((index) => (
            <Box
              key={index}
              background="white"
              height="s48"
              width="s2"
              style={{
                transform: 'rotate(45deg)',
                marginLeft: '4px',
              }}
            ></Box>
          ))}
        </Box>
      </Box>
    </>
  )
}

export default ColorBlock
